import axios from 'axios';

const log = require("loglevel").getLogger("HeatmapService");
log.setLevel("error");

export const loadHeatmapPicklists = id => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/heatmap/get/picklists`)
		.then(async response => {
			const res = response.data.data;
			log.debug("HeatmapService -> loadHeatmapPicklists -> return");
			return res;
		})
		.catch(response => {
			log.debug("HeatmapService -> loadHeatmapPicklists -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadHeatmapById = id => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/heatmap/get/id`, {id})
		.then(async response => {
			const res = response.data.data;
			log.debug("HeatmapService -> loadHeatmapById -> return");
			return res;
		})
		.catch(response => {
			log.debug("HeatmapService -> loadHeatmapById -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadHeatmaps = (selectedFilters, forceReload) => {
	console.log(selectedFilters);

	return axios.post(`${process.env.REACT_APP_HOST_URL}/heatmap/get`, {selectedFilters, forceReload: forceReload === true})
		.then(async response => {
			const res = response.data;
			log.debug("HeatmapService -> loadHeatmaps -> return");
			return res;
		})
		.catch(response => {
			log.debug("HeatmapService -> loadHeatmaps -> error: ");
			log.debug(response);
			return null;
		});
};

export const saveHeatmap = (heatmapId, updatedFields, selectedVendor) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/heatmap`, {heatmapId, updatedFields, selectedVendor})
		.then(async response => {
			const res = response.data;
			log.debug("HeatmapService -> saveHeatmap -> return");
			return res;
		})
		.catch(response => {
			log.debug("HeatmapService -> saveHeatmap -> error: ");
			log.debug(response);
			return null;
		});
};

export const createHeatmap = (updatedFields) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/heatmap`, {heatmapId: '-1', updatedFields})
		.then(async response => {
			const res = response.data;
			log.debug("HeatmapService -> createHeatmap -> return");
			return res;
		})
		.catch(response => {
			log.debug("HeatmapService -> createHeatmap -> error: ");
			log.debug(response);
			return null;
		});
};
